<template>
  <div class="bg-white antialiased">
    <section class="py-16 sm:py-24">
      <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        
        <div class="text-center">
          <h2 class="text-base font-semibold text-orange-600 tracking-wider uppercase">
            Nossas Soluções
          </h2>
          <p class="mt-4 text-3xl sm:text-4xl lg:text-5xl font-extrabold text-gray-900 tracking-tight">
            Tecnologias que Aumentam seu Faturamento
          </p>
          <p class="mt-5 max-w-3xl mx-auto text-lg text-gray-500">
            Nossas soluções são desenvolvidas para gerar impacto direto no seu faturamento, com foco em resultados mensuráveis e rápido retorno sobre investimento.
          </p>
        </div>

        <div class="mt-20 grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-3">
          <div 
            v-for="solution in solutions" 
            :key="solution.title"
            class="bg-white rounded-2xl border border-gray-200 shadow-xl flex flex-col"
          >
            <div class="p-8 flex-grow flex flex-col">
              <div class="h-16 mb-6 flex items-center justify-center">
                <img :src="solution.logoSrc" :alt="solution.title" class="max-h-full" />
              </div>

              <h3 class="text-2xl font-bold text-gray-900 text-center">
                {{ solution.title }}
              </h3>
              <p class="mt-4 text-gray-600 text-center flex-grow">
                {{ solution.description }}
              </p>

              <div class="mt-8 bg-gray-100 rounded-xl p-6">
                <h4 class="font-bold text-gray-800">Resultados típicos:</h4>
                <ul class="mt-4 space-y-2 text-gray-700">
                  <li v-for="result in solution.results" :key="result" class="flex items-start">
                    <span class="text-green-500 font-bold mr-2 mt-1">&#43;</span>
                    <span>{{ result }}</span>
                  </li>
                </ul>
              </div>
            </div>

            <div class="p-8 pt-0">
                <a href="#" class="block w-full text-center bg-orange-500 text-white font-bold uppercase text-sm py-3 px-6 rounded-lg hover:bg-orange-600 transition-transform duration-300 ease-in-out hover:scale-105 shadow-md">
                  Quero aumentar minhas vendas
                </a>
            </div>
          </div>
        </div>

      </div>
    </section>
  </div>
</template>

<script setup>
import { ref } from 'vue';

const solutions = ref([
  {
    logoSrc: '/images/overx-admin.png',
    title: 'Over Admin',
    description: 'Área de trabalho completa para gerenciar todas as operações do seu negócio em um único lugar, com painéis personalizados e relatórios avançados.',
    results: [
      '75% em produtividade',
      '-45% em tempo de gestão',
      '+60% em decisões acertadas'
    ]
  },
  {
    logoSrc: '/images/overx-driver.png',
    title: 'Over Drive',
    description: 'Otimize suas entregas, reduza custos e aumente a satisfação dos clientes com nossa plataforma de logística inteligente.',
    results: [
      '-35% em tempo de entrega',
      '+65% em satisfação',
      '+40% em pedidos por cliente'
    ]
  },
  {
    logoSrc: '/images/overx-store.png',
    title: 'Over Store',
    description: 'Crie uma loja virtual completa com recursos avançados de conversão que aumentam suas vendas online em até 200%.',
    results: [
      '+200% em vendas online',
      '-45% em abandono de carrinho',
      '+55% em taxa de conversão'
    ]
  }
]);
</script>

<style scoped>
/* Estilos adicionais, se necessário. Tailwind CSS cuida da maior parte. */
</style>